import { Breadcrumb, Button, Layout, Menu, MenuProps, Tooltip, Typography } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { CSSProperties, ReactNode, useContext, useEffect, useState } from 'react';
import AppBar from '../navigation/appbar';
import {
    ApartmentOutlined,
    RightCircleOutlined,
    BuildOutlined,
    FileSearchOutlined,
    FolderOutlined,
    FundProjectionScreenOutlined,
    FundViewOutlined,
    GroupOutlined,
    InfoCircleOutlined,
    MoneyCollectOutlined,
    RadarChartOutlined,
    TeamOutlined,
    HomeOutlined,
    ReadOutlined,
    FlagOutlined,
    UsergroupAddOutlined,
    LeftCircleOutlined
} from '@ant-design/icons';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import Header from '../components/header';
import { CompanyContext } from '../../Contexts/CompanyContext';
import Loader from '../../Components/Shared/Loader';
import { LoaderContext } from '../contexts/LoaderContext';
import FooterCustom from '../components/footer';
import './mainLayout.css';

type MenuItem = Required<MenuProps>['items'][number];

const sharedButtonStyleExpanded: CSSProperties = {
    background: '#FFFFFF',
    color: 'black',
    marginBottom: '6px',
    justifyContent: 'flex-start'
}

const sharedButtonStyleExpandedBottom: CSSProperties = {
    background: '#FFFFFF',
    color: 'black',
    justifyContent: 'flex-start'
}

const sharedMenuButtonStyleShrunk: CSSProperties = {
    background: '#FFFFFF',
    color: 'black',
}

const sharedMenuButtonStyleShrunkBottom: CSSProperties = {
    background: '#FFFFFF',
    color: 'black',
    marginTop: '6px'
}

const sharedButtonStyleShrunk: CSSProperties = {
    background: '#0000A4',
    color: 'white',
    width: '100%',
    marginBottom: '6px'
}

const siderStyle: CSSProperties = {
    overflow: 'auto',
    height: '100vh',
    position: 'sticky',
    insetInlineStart: 0,
    top: 0,
    left: 0,
    scrollbarWidth: 'thin',
    scrollbarColor: 'unset',
};

export default function MainLayout({ hideNavigation, hideHeader, hideNavBar }: { hideHeader?: boolean, hideNavigation?: boolean, hideNavBar?: boolean }) {

    const [collapsed, setCollapsed] = useState(true);
    const navigate = useNavigate();
    const { company } = useContext(CompanyContext)
    const { isLoading } = useContext(LoaderContext);
    const [keySelected, setKeySelected] = useState("home");

    const redirectRoute = () => {
        navigate(`/`)
    }

    const redirectHome = () => {
        navigate(`/home/${company.id}`)
    }

    const redirectToFileManager = () => {
        navigate(`/fileManager/${company.id}`)
    }

    const items: MenuItem[] = [
        {
            key: 'home',
            label: <Link to={`/home/${company.id}`}>Página Inicial</Link>,
            icon: <HomeOutlined />
        },
        {
            key: 'financial',
            label: <Link to={`/financialAnalysis/${company.id}`}>Análise Financeira</Link>,
            icon: <FileSearchOutlined />,
        },
        {
            key: 'map',
            label: 'Mapeamento',
            icon: <FundProjectionScreenOutlined />,
            children: [
                {
                    key: 'map1',
                    label: <Link to={`/grantsSearcher/${company.id}`}>Buscador de Linhas</Link>
                },
                {
                    key: 'map2',
                    label: <Link to={`/projectInformation/${company.id}`}>Identificação de Projeto</Link>
                },
                {
                    key: 'map3',
                    label: <Link to={`/projectGrouping/${company.id}`}>Agrupamento de Projetos</Link>
                },
                {
                    key: 'map4',
                    label: <Link to={`/recommendations/${company.id}`}>Recomendação (Match)</Link>
                },
                {
                    key: 'map5',
                    label: <Link to={`/opportunitiesPanels/${company.id}`}>Painel de Oportunidades</Link>
                },
            ],
        },
        {
            key: 'plea',
            label: 'Pleito de Solicitação',
            icon: <FlagOutlined />,
            children: [
                {
                    key: 'plea1',
                    label: <Link to={`/register/${company.id}`}>Cadastro FINEP</Link>,
                    disabled: false
                },
                {
                    key: 'plea2',
                    label: <Link to={`/plea/financial/list/${company.id}`}>Pleito técnico e Financeiro</Link>,
                    disabled: false
                },
            ],
        },
        {
            key: 'hiring',
            label: 'Contratação',
            icon: <TeamOutlined />,
            children: [
                {
                    key: 'hiring1',
                    label: 'Cadastro', //<Link to={`/hiring/${company.id}`}>Cadastro</Link>,
                    disabled: true
                },
            ],
        },
        {
            key: 'accountability',
            label: 'Prestação de Contas',
            disabled: true,
            icon: <MoneyCollectOutlined />
        },
        {
            key: 'dossie',
            label: 'Dossiês',
            icon: <ReadOutlined />,
            children: [
                {
                    key: 'dossie1',
                    label: 'Dossiê Digital',
                    disabled: true
                },
            ],
        },
    ];

    const ExpandedMenu = () => {
        return (
            <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>

                <div className='menu-container-sider-expanded'>
                    <div style={{ width: '100%' }}>
                        <div onClick={() => redirectHome()} style={{ height: '75px', width: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex', cursor: 'pointer' }}>
                            <img alt='logo_fi' src='img/logo_footer.png' />
                            <Typography style={{ color: 'white', marginLeft: '10px' }}>Helping Ideas Grow</Typography>
                        </div>


                        <div style={{ display: 'flex', marginTop: '22px', width: '100%', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <Menu
                                style={{ background: '#0000a4', width: '100%', maxHeight: '61vh', overflowX: 'scroll' }}
                                color='white'
                                mode="inline"
                                onClick={() => setCollapsed(!collapsed)}
                                items={items}
                                selectedKeys={[keySelected]}
                                onSelect={(e) => handleClick(e.key)}
                            />
                        </div>
                    </div>
                    <div style={{ width: '100%' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '8px', marginRight: '8px' }}>
                            <Button onClick={() => { redirectToFileManager(); setCollapsed(!collapsed) }} style={sharedButtonStyleExpanded} icon={<FolderOutlined />}>Gerenciador de Documentos</Button>
                            <Button onClick={() => { redirectRoute(); setCollapsed(!collapsed) }} style={sharedButtonStyleExpandedBottom} icon={<UsergroupAddOutlined />}>Seleção de Empresas</Button>
                        </div>
                        <hr className='horizon-line-sider' />
                        <div style={{
                            width: '100%',
                            color: 'white',
                            display: 'flex',
                        }}>
                            <Typography style={{
                                justifyContent: 'flex-start',
                                width: '100%',
                                margin: '0px 10px',
                                display: 'flex',
                                alignItems: 'center',
                                color: 'white',
                                cursor: 'pointer'
                            }} onClick={() => setCollapsed(!collapsed)}><LeftCircleOutlined style={{ marginRight: '10px' }} />Ocultar</Typography>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const ShrunkMenu = () => {
        return (
            <div style={{ width: '48px', height: '100%', display: 'flex', flexDirection: 'column' }}>
                <div className='menu-container-sider'>
                    <div className='menu-not-expanded'>
                        <div onClick={() => redirectHome()} style={{ height: '75px', justifyContent: 'center', alignItems: 'center', display: 'flex', cursor: 'pointer' }}>
                            <img alt='logo_fi' src='img/logo_footer.png' />
                        </div>

                        <Menu
                            selectedKeys={[keySelected]}
                            mode="vertical"
                            style={{ display: 'flex', background: '#0000a4', alignItems: 'center', marginTop: '22px', flexDirection: 'column' }}
                            items={items}
                            onSelect={(e) => handleClick(e.key)}
                        />
                    </div>

                    <div>
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '8px', marginRight: '8px', alignItems: 'center' }}>
                            <Tooltip title={'Gerenciador de Documentos'} placement='right'>
                                <Button onClick={() => redirectToFileManager()} style={sharedMenuButtonStyleShrunk} icon={<FolderOutlined />}></Button>
                            </Tooltip>
                            <Tooltip title={'Seleção de Empresas'} placement='right'>
                                <Button onClick={() => redirectRoute()} style={sharedMenuButtonStyleShrunkBottom} icon={<UsergroupAddOutlined />}></Button>
                            </Tooltip>
                        </div>
                        <hr className='horizon-line-sider' />
                        <div style={{
                            width: '100%',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <RightCircleOutlined size={80} onClick={() => setCollapsed(!collapsed)} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const handleClick = (e: string) => {
        setKeySelected(e);
        localStorage.setItem('selectedKey', e);
    };

    useEffect(() => {
        const savedKey = localStorage.getItem('selectedKey');
        if (savedKey) {
            setKeySelected(savedKey);
        }
    }, []);

    return (
        <Layout style={{ height: '100%', minHeight: '100vh' }}>

            {
                hideNavigation
                    ? <></>
                    : <Sider style={siderStyle} collapsedWidth={48} width={'290px'} trigger={null} collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
                        {collapsed ? <ShrunkMenu /> : <ExpandedMenu />}
                    </Sider>
            }

            <Layout>
                {
                    hideNavBar
                        ? <></>
                        : <Layout.Header style={{ padding: '0px', background: '#0000A4', position: 'sticky', top: '0', left: '0', zIndex: '999', height: '45px' }}>
                            <AppBar hideNavigation={hideNavigation} />
                        </Layout.Header>
                }

                <Layout.Content style={{ margin: '0 16px', marginBottom: '40px' }}>
                    {isLoading && <Loader />}

                    {hideHeader ? null : <Header />}
                    <Outlet />
                </Layout.Content>

                <Layout.Footer style={{ textAlign: 'end', padding: '8px 20px', width: '100%', position: 'fixed', bottom: '0', left: '0', zIndex: '998' }}>
                    <FooterCustom />
                </Layout.Footer>

            </Layout>

        </Layout>
    )
}
